// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"874":"58296f0e","959":"4bb70dad"}[chunkId] + ".js";
};